import { useState, useEffect } from "react"

export default function AddressForm({
  addr = {},
  index = 0,
  showDelete = false,
  onDelete,
  onUpdate,
}) {
  // ✅ FIX: safer check
  const hasAddress = addr && Object.keys(addr).length > 0
  const [notice, setNotice] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [form, setForm] = useState(addr)

  useEffect(() => {
    setForm(addr)
  }, [addr])

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSave = () => {
    if (!addr?._id) return
    onUpdate(addr._id, form)
    setIsEditing(false)
  }

  return (
    <div className="card p-3 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="mb-3">Address {index + 1}</h5>

        {/* ✅ FIX: always show if ID exists */}
        {addr?._id && (
          <div>
            <button
              className="btn btn-sm btn-outline-primary me-2"
              onClick={() => setIsEditing((prev) => !prev)}
            >
              {isEditing ? "Cancel" : "Edit"}
            </button>

            {showDelete && (
              <button
                className="btn btn-danger btn-sm"
                onClick={() => onDelete(addr._id)}
              >
                Delete
              </button>
            )}
          </div>
        )}
      </div>

      {[
        ["full_name", "Contact Person"],
        ["address1", "Address Line 1"],
        ["address2", "Address Line 2"],
        ["city", "City"],
        ["state", "State"],
        ["zip", "ZIP Code"],
        ["country", "Country"],
      ].map(([key, label]) => (
        <div className="mb-3" key={key}>
          <label className="form-label small text-muted mb-1 text-start w-100">
            {label}
          </label>
          <input
            name={key}
            className="form-control"
            value={form[key] || ""}
            onChange={handleChange}
            disabled={!isEditing}
          />
        </div>
      ))}

      {isEditing && addr?._id && (
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-success btn-sm"
            style={{ width: "100px" }}
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      )}
    </div>
  )
}
